import AccessError from './AccessError';

export default AccessError;
